/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/explicit-module-boundary-types */
import { COVERAGE_NAMES } from "@platform/rfp-core";
import { Alert } from "@platform/design-system";

import { BasicLifeForm } from "../../RFP/coverages/CoverageForms/BasicLifeAD&D";
import { VisionForm } from "../../RFP/coverages/CoverageForms/Vision";
import { AccidentForm } from "../../RFP/coverages/CoverageForms/Accident";
import { LongTermDisabilityForm } from "../../RFP/coverages/CoverageForms/LongTermDisability";
import { ShortTermDisabilityForm } from "../../RFP/coverages/CoverageForms/ShortTermDisability";
import { FamilyMedicalLeaveAdministrationForm } from "../../RFP/coverages/CoverageForms/FamilyMedicalLeaveAdministration";
import { VoluntaryLifeADDForm } from "../../RFP/coverages/CoverageForms/VoluntaryLifeADD";
import { EmployeeAssistanceProgramForm } from "../../RFP/coverages/CoverageForms/EmployeeAssistanceProgram";
import { DentalForm } from "../../RFP/coverages/CoverageForms/Dental";
import { IndividualDisabilityForm } from "../../RFP/coverages/CoverageForms/IndividualDisability";
import { StateDisabilityLeavesForm } from "../../RFP/coverages/CoverageForms/StateDisabilityLeaves";

const {
  ACCIDENT,
  VISION,
  CANCER,
  CI,
  HOSPITAL,
  WHOLE_LIFE,
  LTD,
  FMLA,
  BASIC_LIFE,
  VOLUNTARY_LIFE,
  STD,
  EAP,
  DENTAL,
  DENTAL_PPO,
  DENTAL_DHMO,
  INDIVIDUAL_DISABILITY,
  SDL,
} = COVERAGE_NAMES;

function RfpCoverageForm({
  coverage,
  currentPlanIndex,
  onFormChange,
  onSetCurrentPlanIndex,
}) {
  if (!coverage) {
    return (
      <Alert severity="info" title="No coverages added yet">
        Start by selecting any current or new coverages you&apos;d like to
        quote.
      </Alert>
    );
  }
  const coverageName = coverage.name;

  switch (coverageName) {
    case VISION:
      return (
        <VisionForm
          activeTab={currentPlanIndex}
          onChangeTab={onSetCurrentPlanIndex}
          coverage={coverage}
          onFormChange={onFormChange}
        />
      );
    case ACCIDENT:
    case CANCER:
    case CI:
    case HOSPITAL:
    case WHOLE_LIFE:
      // use key to force re-render when coverage changes
      return (
        <AccidentForm
          key={coverageName}
          coverage={coverage}
          onFormChange={onFormChange}
        />
      );
    case LTD:
      return (
        <LongTermDisabilityForm
          key={coverageName}
          activeTab={currentPlanIndex}
          onChangeTab={onSetCurrentPlanIndex}
          coverage={coverage}
          onFormChange={onFormChange}
        />
      );
    case FMLA:
      return (
        <FamilyMedicalLeaveAdministrationForm
          coverage={coverage}
          onFormChange={onFormChange}
        />
      );
    case BASIC_LIFE:
      return <BasicLifeForm coverage={coverage} onFormChange={onFormChange} />;
    case VOLUNTARY_LIFE:
      return (
        <VoluntaryLifeADDForm coverage={coverage} onFormChange={onFormChange} />
      );
    case STD:
      return (
        <ShortTermDisabilityForm
          key={coverageName}
          activeTab={currentPlanIndex}
          onChangeTab={onSetCurrentPlanIndex}
          coverage={coverage}
          onFormChange={onFormChange}
        />
      );
    case EAP:
      return (
        <EmployeeAssistanceProgramForm
          coverage={coverage}
          onFormChange={onFormChange}
        />
      );
    case DENTAL:
    case DENTAL_PPO:
    case DENTAL_DHMO:
      // use key to force re-render when coverage changes
      return (
        <DentalForm
          key={coverageName}
          activeTab={currentPlanIndex}
          onChangeTab={onSetCurrentPlanIndex}
          coverage={coverage}
          onFormChange={onFormChange}
        />
      );
    case INDIVIDUAL_DISABILITY:
      return (
        <IndividualDisabilityForm
          coverage={coverage}
          onFormChange={onFormChange}
        />
      );
    case SDL:
      return (
        <StateDisabilityLeavesForm
          coverage={coverage}
          onFormChange={onFormChange}
        />
      );
    default:
      return <div>Form Not found</div>;
  }
}

export default RfpCoverageForm;
